const SubscriptionDataContent = ({ children }: { children: React.ReactNode }) => {
  return <p className="text-sm font-medium text-black400">{children}</p>;
};

export default SubscriptionDataContent;
